import { color } from 'theme/tokens/color'

export type EditorTheme = {
    minElSize: number
    minHitSize: number
    snapTolerance: number
    minCanvasSize: number
    maxCanvasSize: number
    minZoom: number
    maxZoom: number
    displayScale: number
    defaultCanvasW: number
    defaultCanvasH: number
    defaultCanvasBg: string
    defaultGridSize: number
    nudgeStep: number
    nudgeStepFast: number
    fitPadding: number
    demoFill: string
    dragThreshold: number
    rowHeight: number
    tableColWidth: number
    listPad: number
    listHorizontalItemW: number
    maxListItems: number
    maxTableRows: number
    maxTableCols: number
}

export const defaultEditorTheme: EditorTheme = {
    minElSize: 24,
    minHitSize: 48,
    snapTolerance: 6,
    minCanvasSize: 320,
    maxCanvasSize: 7680,
    minZoom: 0.1,
    maxZoom: 4,
    displayScale: 0.5,
    defaultCanvasW: 1920,
    defaultCanvasH: 1080,
    defaultCanvasBg: color.bgWhitePrimary,
    defaultGridSize: 50,
    nudgeStep: 1,
    nudgeStepFast: 10,
    fitPadding: 48,
    demoFill: color.blue,
    dragThreshold: 5,
    rowHeight: 36,
    tableColWidth: 120,
    listPad: 8,
    listHorizontalItemW: 160,
    maxListItems: 40,
    maxTableRows: 20,
    maxTableCols: 20,
}
